import type { FaireProductEntity } from "../../entity_types/product";

export const p_7y8kq2n8ym: FaireProductEntity = {
  token: "p_7y8kq2n8ym",
  type: "product",
  name: "Olive Baseball Cap/Dad Hat",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/9cb8320c73766986024c31940a9c6347756cb5d56b644ee5f7103c5226df7df3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16891d32447d8f17334cc45b0d0c3acf9944fc390de71ad8c379132238538f70.jpeg",
    "https://cdn.faire.com/fastly/85bc3039c4682c29e9fa9cb997f73a890b34a247f02219b0cbb23013c0eb1780.jpeg"
  ],
  priceDollars: 17.5,
  description: "This soft, adjustable hat features a charming olive icon that food lovers and aperitivo enthusiasts will adore. Wear it running weekend errands, strolling through the city, or hosting your next dinner party—it’s a playful, whimsical accessory for everyday and makes a thoughtful gift for friends, family, or fellow foodies.\n\nGood to know:\n\n * Deep olive green hat with illustrated olive embroidered design. \n * Features adjustable back buckle \n * Designed in Portland, Maine by Mel Andrel ",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:09.316Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
